import { render } from "./N2FAddEdit.vue?vue&type=template&id=aae50450"
import script from "./N2FAddEdit.vue?vue&type=script&lang=ts"
export * from "./N2FAddEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script